import '@/app/styles/_index.scss'
import '@/app/styles/globals.css'
import '@/shared/vendor/phantom-ui/phantom-ui.standalone.js'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'

const CHUNK_RELOAD_KEY = 'vbdt:chunk-reload-at'
const CHUNK_RELOAD_WINDOW_MS = 10_000

// Sau deploy, tab cũ xin chunk đã đổi mã băm → tải lại một lần để lấy bản mới.
// Vừa tải lại mà vẫn lỗi thì để error boundary hiển thị, tránh vòng lặp reload.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY))
    if (Date.now() - last < CHUNK_RELOAD_WINDOW_MS) return
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
  } catch {
    return
  }
  event.preventDefault()
  window.location.reload()
})

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error(
    "Root element not found. Check if it's in your index.html or if the id is correct."
  )
}

ReactDOM.createRoot(rootElement).render(
  <Suspense fallback="loading...">
    <App />
  </Suspense>
)
